import { render, staticRenderFns } from "./TicketFeedback.vue?vue&type=template&id=50d2affe&"
import script from "./TicketFeedback.vue?vue&type=script&lang=ts&"
export * from "./TicketFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports